import(/* webpackMode: "eager", webpackExports: ["AppLayoutClient"] */ "/vercel/path0/app/(app)/layout-client.tsx");
